import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { connectionsAPI } from '../../services/api';
import { packPath } from './dataSourceFormat';
import '../../styles/DatasetManagement.css';
import '../../styles/DataSources.css';

/** Where the source system sends the browser back after sign-in. */
export default function ConnectionCallbackPage() {
  const { connector } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(() => (params.get('error') ? (params.get('error_description') || 'The sign-in was cancelled.') : ''));
  // The code works once, so a repeated effect must not send it twice.
  const sent = useRef(false);

  useEffect(() => {
    const code = params.get('code');
    const state = params.get('state');
    if (sent.current || params.get('error')) return;
    sent.current = true;
    if (!code || !state) {
      setError('The sign-in response is incomplete.');
      return;
    }
    // QuickBooks names the company chosen (realmId) alongside the code.
    const realmId = params.get('realmId');
    connectionsAPI.completeOAuth(connector, { code, state, ...(realmId ? { realmId } : {}) })
      .then(() => navigate(packPath(connector), { replace: true }))
      .catch((err) => setError(err?.response?.data?.error || err?.message || 'The sign-in could not be completed.'));
  }, [connector, params, navigate]);

  return (
    <div className="dataset-management data-source-detail">
      <section className="source-card">
        <h3>Connecting</h3>
        {error
          ? (
            <>
              <div className="error-message" role="alert">{error}</div>
              <p className="source-hint"><Link to={packPath(connector)}>Back to the data source</Link></p>
            </>
          )
          : <p className="source-hint">Finishing the sign-in…</p>}
      </section>
    </div>
  );
}
